import React, { FunctionComponent, MouseEventHandler } from 'react';
import './action-button.scss';

interface IProps {
  customClasses?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  isDisabled?:boolean;
}

const ActionButton: FunctionComponent<IProps> = ({ isDisabled, children, customClasses, ...props }): JSX.Element => (
  <button disabled={isDisabled} className={`action-button ${customClasses}`} {...props}>
    {children}
  </button>
);

export default ActionButton;
